/**
 * @flow
 */
import React from "react";
import {Provider, useSelector} from 'react-redux';
import {Router} from "react-router-dom";
import EgretTheme from "./EgretLayout/EgretTheme/EgretTheme";
import AppContext from "./appContext";
import history from "../history.js";
import routes from "./routes";
import {store} from "./redux/store";
import API from './services/API';
import Storage from './services/Storage';
import EgretLayout from "./EgretLayout/EgretLayout";
import "../styles/_app.scss";
import {initUser} from './redux/actions/actions';
import {ROUTE} from './settings';
import Nav from './services/Nav';
import AlertModal from './components/ui/AlertModal';
import ConfirmModal from './components/ui/ConfirmModal';
import {useSharedData} from './hooks/data-view-hooks';
import {setNotiCount} from './redux/reducers/notificationReducer';

const App = () => {
  // NOTE: API 서비스가 디스패치 함수에 접근할수 있도록 설정하여
  // 디스패치가 패러미터로 넘어오지 않아도 디스패치를 할수 있도록함
  API.dispatch = store.dispatch;
  return (
    <AppContext.Provider value={{routes}}>
      <Provider store={store}>
        <EgretTheme>
          <Router history={history}>
            <AuthListener>
              <EgretLayout />
              <AlertModal />
              <ConfirmModal />
            </AuthListener>
          </Router>
        </EgretTheme>
      </Provider>
    </AppContext.Provider>
  );
};

let initialized = false;
const AuthListener = (props) => {
  const user = useSelector((state) => state.user);
  const {companies, queryCompanies} = useSharedData();
  const [ready, setReady] = React.useState(false);
  React.useEffect(() => {
    setReady(false);
    if(user.id !== 0) {
      // 사용자의 상태가 변경될때마다 노티 카운트 쿼리
      API.notiCount().then(res => {
        setNotiCount(res?.notiCount >= 0 ? res.notiCount : 0, store.dispatch);
      }).catch(/*오류는 무시함*/);
      if(initialized === false) {
        initialized = true;
        process.env.NODE_ENV !== 'production' && console.log('[App] 사용자 로그인', {user});
        // 사용자가 존재하는 경우 사용자의 컴퍼니 목록을 쿼리함
        if ((companies ?? []).length <= 0) {
          queryCompanies().then(() => setReady(true))
        } else {
          setReady(true);
        }
      } else {
        process.env.NODE_ENV !== 'production' && console.log('[App] 프로파일 변경', {user});
        setReady(true);
      }
    } else {
      initialized = false;
      process.env.NODE_ENV !== 'production' && console.log('[App] 사용자 로그아웃', {user});
      Nav.push(ROUTE.SIGN_IN);
      setReady(true);
    }
  }, [user]);
  return ready ? props.children : null;
};

initUser();

// 라우터 리스너를 설정하여 라우트가 변경될때 마다 특정 액션을 취할수 있도록함
Nav.addListener((location, action) => {
  const state = store.getState();
  const {user} = state;
  if (user?.id > 0 && user?.token && Storage.token) {
    // 사용자가 로그인한 경우 라우트가 변경될때 노티 갯수를 쿼리
    API.notiCount().then(res => {
      setNotiCount(res?.notiCount >= 0 ? res.notiCount : 0, store.dispatch);
    }).catch(/*오류는 무시함*/);
  }
});

export default App;
